module.exports = __webpack_public_path__ + "static/media/tutorial-banner.53e1ed73.png";